import React from "react";

/**
 * DisputeReviewModal — sub-modal of DisputesSection. Renders the
 * 4-action grid (DISMISS / VOID / FLIP A / FLIP B) + optional resolution
 * note textarea.
 */
export function DisputeReviewModal({ challenge, note, setNote, onClose, onDismiss, onVoid, onFlip }) {
  if (!challenge) return null;
  const teamAName = (challenge.team_a || {}).name || "TEAM A";
  const teamBName = (challenge.team_b || {}).name || "TEAM B";
  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
      data-testid="admin-dispute-review-modal"
      onClick={onClose}
    >
      <div
        className="glass-strong rounded-3xl p-6 w-full max-w-md border-2 border-[#14b8a6]/60"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-[10px] tracking-[4px] text-[#14b8a6] font-bold">REVIEW DISPUTE</p>
        <p className="text-white text-sm mt-1 truncate">
          {teamAName} {challenge.score_a}-{challenge.score_b} {teamBName}
        </p>
        <textarea
          data-testid="admin-dispute-note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          maxLength={600}
          rows={3}
          placeholder="Resolution note (optional, audit log)…"
          className="w-full mt-4 bg-black/40 border border-white/10 rounded-xl p-2 text-[12px] text-white"
        />
        <div className="grid grid-cols-2 gap-2 mt-4">
          <button
            type="button"
            onClick={() => onDismiss(challenge)}
            data-testid="admin-dispute-dismiss"
            className="text-[10px] tracking-widest px-3 py-2 rounded-xl bg-white/10 text-white hover:bg-white/15"
          >
            DISMISS (RESULT STANDS)
          </button>
          <button
            type="button"
            onClick={() => onVoid(challenge)}
            data-testid="admin-dispute-void"
            className="text-[10px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/15 text-[#14b8a6] border border-[#14b8a6]/40 hover:bg-[#14b8a6]/25"
          >
            VOID MATCH
          </button>
          <button
            type="button"
            onClick={() => onFlip(challenge, challenge.from_team_id)}
            data-testid="admin-dispute-flip-a"
            className="text-[10px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/15 text-[#14b8a6] border border-[#14b8a6]/40 hover:bg-[#14b8a6]/25 truncate"
          >
            <i className="fas fa-trophy mr-1" />{teamAName} WINS
          </button>
          <button
            type="button"
            onClick={() => onFlip(challenge, challenge.to_team_id)}
            data-testid="admin-dispute-flip-b"
            className="text-[10px] tracking-widest px-3 py-2 rounded-xl bg-[#14b8a6]/15 text-[#14b8a6] border border-[#14b8a6]/40 hover:bg-[#14b8a6]/25 truncate"
          >
            <i className="fas fa-trophy mr-1" />{teamBName} WINS
          </button>
        </div>
        <button
          type="button"
          onClick={onClose}
          data-testid="admin-dispute-close"
          className="mt-3 w-full text-[10px] tracking-widest px-3 py-2 rounded-xl btn-ghost"
        >
          CANCEL
        </button>
      </div>
    </div>
  );
}
